import React from 'react';
import { useDispatch } from 'react-redux';
import { requestFollow, retractRequestFollow, acceptFollowRequest, denyFollowRequest } from '../ducks/followerRequests';
import { ACCEPT_ACTION, DENY_ACTION, FOLLOW_ACTION, RETRACT_REQUEST_ACTION } from '../constants';

const ACTIONS = {
  [FOLLOW_ACTION]: requestFollow,
  [RETRACT_REQUEST_ACTION]: retractRequestFollow,
  [ACCEPT_ACTION]: acceptFollowRequest,
  [DENY_ACTION]: denyFollowRequest
};

const useConnectAction = (userConnection, actionKey) => {
  const dispatch = useDispatch();

  return () => {
    const { href, method } = userConnection.actions[actionKey];
    dispatch(ACTIONS[actionKey]({ href, method, userConnection, actionKey }));
  };
};

export const useFollowRequest = userConnection => useConnectAction(userConnection, FOLLOW_ACTION);
export const useRetractRequest = userConnection => useConnectAction(userConnection, RETRACT_REQUEST_ACTION);
export const useAccept = userConnection => useConnectAction(userConnection, ACCEPT_ACTION);
export const useDeny = userConnection => useConnectAction(userConnection, DENY_ACTION);

export default useConnectAction;
